import { apiClient, unwrap } from '@/lib/api-client';
import type { ApiSuccess } from '@/types/api';

/**
 * Grup WhatsApp pengguna SIPAUD — satu tautan milik platform, disetel Super
 * Admin dan dibaca seluruh lembaga.
 *
 * String kosong berarti belum diisi: tombolnya tidak ditampilkan sama sekali,
 * bukan ditampilkan mati.
 */
export interface PlatformCommunity {
  whatsappGroupUrl: string;
}

export const platformCommunityService = {
  /** Konsol platform — yang menyetel tautannya. */
  get(): Promise<PlatformCommunity> {
    return unwrap(apiClient.get<ApiSuccess<PlatformCommunity>>('/admin/platform-community'));
  },

  save(payload: PlatformCommunity): Promise<PlatformCommunity> {
    return unwrap(apiClient.put<ApiSuccess<PlatformCommunity>>('/admin/platform-community', payload));
  },

  /** Dashboard lembaga — yang membaca tautannya. */
  getForTenant(): Promise<PlatformCommunity> {
    return unwrap(apiClient.get<ApiSuccess<PlatformCommunity>>('/platform-community'));
  },
};
